<template>
  <loading-view :loading="loading">
    <div class="mx-6 mt-4">
      <div class="flex my-8 align-items-center">
        <div class="h3 mb-0 mr-3">{{ trans('dashboard.integrations.title') }}</div>
        <inertia-link v-if="$can('integrations.create')" class="button" :href="route('wizard.index')">
          <svg class="icon add_icon">
            <use xlink:href="#add-icon"></use>
          </svg>
          {{ trans('dashboard.integrations.add') }}
        </inertia-link>
      </div>
      <div class="mb-8 grid-3" v-if="integrations.length">
        <integration
          v-for="integration in integrations"
          :key="`integration-${integration.id}`"
          :integration="integration"
          :user="user"
          @deleted="handleDeletedIntegration(integration.id)"
        />
      </div>
      <div v-else>
        <wizard-button
          :dynamic="false"
          modifier="border-2 border-dashed flex items-center justify-around cursor-pointer card_add"
          :disabled="!$can('integrations.create')"
        />
      </div>
    </div>
  </loading-view>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout';
import Integration from '@/components/Dashboard/Integration';
import WizardButton from '@/components/Dashboard/Wizard/WizardButton';

export default {
  layout: DashboardLayout,

  components: {
    Integration,
    WizardButton,
  },

  props: {
    user: Object,
  },

  data: () => ({
    integrations: [],
    loading: true,
  }),

  async beforeMount() {
    await this.fetchIntegrations();

    this.loading = false;
  },

  methods: {
    async fetchIntegrations() {
      await axios.get('/api/integrations').then(({ data }) => (this.integrations = data.data));
    },

    handleDeletedIntegration(integrationId) {
      this.integrations = this.integrations.filter(integration => integration.id !== integrationId);
    },
  },
};
</script>

<style lang="scss">
/* Scoped Styles */

.title {
  padding-bottom: 1rem !important;
  padding-top: 1rem !important;
  line-height: 1.15;
}

.content .inner-box img {
  width: auto;
  max-height: 100px;
  min-height: 100px;
}

.pdd-t-5 {
  padding-top: 5rem;
}

.pdd-l-3 {
  padding-left: 3.5rem;
}

.width-92 {
  width: 92%;
}

.delete-button {
  font-size: 2rem;
  background-color: #d34e59;
  color: #ffffff;
  border-radius: 25px;
  text-align: center;
  line-height: 50px;
  max-width: 50px;
}

.icon-status {
  font-size: 40px;
}

.add {
  &_icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 5px;
    display: inline-block;
  }
}

.rotate {
  &-90 {
    transform: rotate(90deg);
  }
}
</style>
